const request = require('superagent-use')(require('superagent')),
    redirect = require('./superagent-redirect'),
    logError = require('./superagent-logerror');
request.use(
    redirect(() => {
        window.location.href = '#/auth?clear=true';
    })
);
request.use(logError());

export default class SuperagentBase {
    constructor() {
        this.request = request;
    }
}



// WEBPACK FOOTER //
// ./src/shared/superagent-base.js